module.exports = __webpack_public_path__ + "img/cookies.974b288a.png";